import { render, staticRenderFns } from "./NovedadesBanner.vue?vue&type=template&id=6719ffa6&scoped=true&"
import script from "./NovedadesBanner.vue?vue&type=script&lang=js&"
export * from "./NovedadesBanner.vue?vue&type=script&lang=js&"
import style0 from "./NovedadesBanner.vue?vue&type=style&index=0&id=6719ffa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6719ffa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
